import speaker1 from "../../images/speaker1.jpeg"
import speaker2 from "../../images/speaker2.png"
import speaker3 from "../../images/speaker3.jpeg"
import speaker4 from "../../images/speaker4.jpeg"
import speaker5 from "../../images/speaker5.jpeg"
const speakers = [
    {
      name: 'Leslie Alexander',
      role: 'Co-Founder / CEO',
      imageUrl:speaker1,
      location: 'Toronto, Canada',
    },
    {
        name: 'Leslie Alexander',
        role: 'Co-Founder / CEO',
        imageUrl:speaker2,
        location: 'Toronto, Canada',
      },
      {
        name: 'Leslie Alexander',
        role: 'Co-Founder / CEO',
        imageUrl:speaker3,
        location: 'Toronto, Canada',
      },
      {
        name: 'Leslie Alexander',
        role: 'Co-Founder / CEO',
        imageUrl:speaker4,
        location: 'Toronto, Canada',
      },
      {
        name: 'Leslie Alexander',
        role: 'Co-Founder / CEO',
        imageUrl:speaker5,
        location: 'Toronto, Canada',
      },
    // More people...
]

export default function Guest_Speakers() {
    return (
      <div className="bg-background pb-5">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl lg:mx-0">
            <h2 className="text-white text-2xl not-italic font-medium leading-9 font-title">Guest Speakers</h2>
          </div>
          <ul
            role="list"
            className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-5"
          >
            {speakers.map((speaker) => (
              <li key={speaker.name}>
                <img className="aspect-[14/13] w-full object-cover" src={speaker.imageUrl} alt="" />
                <h3 className="mt-6 text-lg not-italic font-text text-white font-bold leading-6">{speaker.name}</h3>
                <p className="text-sm not-italic font-medium leading-5 font-text mt-3 text-white">{speaker.role}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }